/**
 * One facet identifier per concept, shared by every index the search UI
 * queries: classes, educators, and relief listings. An index maps each
 * identifier to its own field, so the identifier is what a URL, a filter
 * store, and a descriptor agree on, and a later capability can carry
 * compatible filters from one index to another. Identifiers never name a
 * field; the field belongs to the index.
 */
export const FACET_IDS = {
  curriculum: "curriculum",
  subject: "subject",
  specialities: "specialities",
  tags: "tags",
  listingType: "listing_type",
  reliefAvailability: "relief_availability",
  deliveryMode: "delivery_mode",
} as const

export type FacetId = (typeof FACET_IDS)[keyof typeof FACET_IDS]
